import axios from "axios";
import { Call } from "../../../domain/call/call";

import { Configuration, CallApi, CallCallResponse, LeadgenStatus, CallCallsReportResponse } from "../generated/callApi";
import { CallInterface } from "../../../useCase/call/adapters/interface";

export class CallsRepository implements CallInterface {
    private service: CallApi;

    constructor() {
        this.service = new CallApi(new Configuration(), process.env.REACT_APP_BACKEND_URL)
    }

    async ReadCallsFiltred(offset: number, limit: number, from: Date, to: Date, entityId?: string , taskName?: string[] , callType?: string , operatorName?: string[], pipelineId?:string, leadStage?: string, triggerTypes?: string[], triggerPhrases?: string[]): Promise<{ count: number, list: Call[] } | Error> {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL || ""}/api/call`, {
                params: buildCallParams(offset, limit, from, to, entityId, taskName, callType, operatorName, pipelineId, leadStage, triggerTypes, triggerPhrases),
                headers: { "Authorization": localStorage.getItem("token") },
                paramsSerializer: { serialize: (params) => serializeCallParams(params) },
            })

            if (response.status === 200) {
                let calls: Call[] = []
                response.data.list!.forEach((callData: CallCallResponse) => {

                    let call = this.toDomainCall(callData)
                    calls.push(call)
                });
                return {count: response.data.count!, list: calls}
            }
        } catch (e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }

            return Error(getApiErrorMessage(e, "Не удалось загрузить звонки"))
        }

        return Error("error authorization")
    }

    async GetAudioLocalLink(url: string): Promise<string | Error> {
        try {
            let response = await this.service.apiCallLinkGet(url, { headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return response.data.link!
            }
        } catch (e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }

            return Error(getApiErrorMessage(e, "Не удалось получить ссылку на запись"))
        }

        return Error("error authorization")
    }

    async GetStatusesList(): Promise<LeadgenStatus[] | Error> {
        try {
            let response = await this.service.apiCallStatusesGet({ headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return response.data
            }
        } catch (e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }

            return Error("error authorization")
        }

        return Error("error authorization")
    }

    async GetOperatorsList(): Promise<string[] | Error> {
        try {
            let response = await this.service.apiCallOperatorsGet({ headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return response.data
            }
        } catch (e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }

            return Error("error authorization")
        }

        return Error("error authorization")
    }

    async GetTasksList(): Promise<string[] | Error> {
        try {
            let response = await this.service.apiCallTasksGet({ headers: { "Authorization": localStorage.getItem("token") } })

            if (response.status === 200) {
                return response.data
            }
        } catch (e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }

            return Error("error authorization")
        }

        return Error("error authorization")
    }

    async SearchTriggerTypes(search: string): Promise<string[] | Error> {
        return this.searchTriggerOptions("trigger-types", search)
    }

    async SearchTriggerPhrases(search: string): Promise<string[] | Error> {
        return this.searchTriggerOptions("trigger-phrases", search)
    }

    private async searchTriggerOptions(path: string, search: string): Promise<string[] | Error> {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL || ""}/api/call/${path}`, {
                params: { search },
                headers: { "Authorization": localStorage.getItem("token") },
            })
            if (response.status === 200) {
                return response.data
            }
        } catch (e) {
            return Error(getApiErrorMessage(e, "Не удалось загрузить варианты триггеров"))
        }
        return Error("Не удалось загрузить варианты триггеров")
    }

    async DownloadXlsx(from: Date, to: Date, entityId?: string , taskName?: string[], callType?: string , operatorName?: string[], pipelineId?: string, leadStage?: string, triggerTypes?: string[], triggerPhrases?: string[]): Promise<CallCallsReportResponse | Error> {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL || ""}/api/call/xlsx`, {
                params: buildCallParams(undefined, undefined, from, to, entityId, taskName, callType, operatorName, pipelineId, leadStage, triggerTypes, triggerPhrases),
                headers: { "Authorization": localStorage.getItem("token") },
                paramsSerializer: { serialize: (params) => serializeCallParams(params) },
            })

            if (response.status === 200) {
                return response.data
            }
        } catch (e) {
            let error: string = ""
            if (axios.isAxiosError(e)) {
                error = e.response?.data.message
            }

            return Error(getApiErrorMessage(e, "Не удалось скачать файл"))
        }

        return Error("Не удалось скачать файл")
    }

    toDomainCall = (call: CallCallResponse) => {
        const result = new Call(call.id!, call.communication_id!, new Date(call.call_date!), call.entity_id!, call.task_name!, call.comment!, call.call_type!, call.call_length!, call.operator_name!, call.pipeline_id!, call.lead_stage!, call.status_id!, call.region!, call.call_link!, new Date(call.created_at!), new Date(call.modified_at!))
        result.SetTriggerData(call.trigger_types || [], call.trigger_phrases || [])
        return result
    }

    
}

const buildCallParams = (offset: number | undefined, limit: number | undefined, from: Date, to: Date, entityId?: string, taskName?: string[], callType?: string, operatorName?: string[], pipelineId?: string, leadStage?: string, triggerTypes?: string[], triggerPhrases?: string[]) => ({
    offset,
    limit,
    from: formatDate(from),
    to: formatDate(to),
    entity_id: entityId,
    task_name: taskName,
    call_type: callType,
    operator_name: operatorName,
    pipeline_id: pipelineId,
    lead_stage: leadStage,
    trigger_type: triggerTypes,
    trigger_phrase: triggerPhrases,
})

const serializeCallParams = (params: Record<string, unknown>) => {
    const searchParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") {
            return
        }
        const queryKey = key === "task_name" ? "task_name[]" : key === "operator_name" ? "operator_name[]" : key === "trigger_type" ? "trigger_type[]" : key === "trigger_phrase" ? "trigger_phrase[]" : key
        if (Array.isArray(value)) {
            value.forEach(item => searchParams.append(queryKey, String(item)))
        } else {
            searchParams.append(queryKey, String(value))
        }
    })
    return searchParams.toString()
}

const getApiErrorMessage = (error: unknown, fallback: string) => {
    if (axios.isAxiosError(error)) {
        const responseData = error.response?.data
        if (typeof responseData === "string" && responseData !== "") {
            return responseData
        }
        if (responseData && typeof responseData.error === "string" && responseData.error !== "") {
            return responseData.error
        }
        if (responseData && typeof responseData.message === "string" && responseData.message !== "") {
            return responseData.message
        }
        if (error.message) {
            return error.message
        }
    }
    return fallback
}

const formatDate = (day: Date) => {
    if (day.getFullYear() === 1) {
        return ""
    }
    const yyyy = day.getFullYear();
    let mm = (day.getMonth() + 1).toString(); // Months start at 0!
    let dd = day.getDate().toString();

    if (dd.length == 1) dd = '0' + dd;
    if (mm.length == 1) mm = '0' + mm;

    return dd + '.' + mm + '.' + yyyy.toString();
}
